import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination } from "../../../../common/pagination";
import ModernPagination from "../../../../common/pagination/ModernPagination";
import Heading from '../../../../common/element/Heading';
import ClientInput from "../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import CompaniesList from './Companies';
import AddEditCompany from './AddEdit';
import { getCompanyList } from '../../../../redux/Companies/companiesSlice';
import {
  selectCompanyList,
  selectCompanyListLoading,
  selectCompanyListTotal
} from '../../../../redux/Companies/companiesSelector';
import { selectUserData } from '../../../../redux/auth/authSelector';
import { ROLES } from '../../../../config/rolePermissions';
import Select from '../../../../common/element/Select';
import StatusSelect from '../../../../common/element/StatusSelect/StatusSelect';

const Companies = () => {
  const totalRecords = useSelector(selectCompanyListTotal);
  const [countData, setCountData] = useState(0);
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const companyList = useSelector(selectCompanyList);
  const loading = useSelector(selectCompanyListLoading);
  const userData = useSelector(selectUserData);
  const isAdmin = userData?.role_name === ROLES.ADMIN;
  console.log("companyList", companyList);
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const [getFilterData, SetFilterData] = useState({
    function_assignment_id: "",
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });
  const [status, setStatus] = useState("false");
  const filteredData = companyList;

  // Search Data
  const handleSearch = (e) => {
    SetFilterData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value.trim(),
      };
    });
  };

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Companies",
          url: "/companies",
          home: "/companies",
        },
      ])
    );
  }, [dispatch]);

  // Function to fetch company list
  const fetchCompanyList = useCallback(() => {
    dispatch(
      getCompanyList({
        page: filterpage,
        limit: filterlimit,
        search: getFilterData.search,
        is_archived: status
      })
    );
  }, [dispatch, filterpage, filterlimit, getFilterData.search, status]);

  useEffect(() => {
    fetchCompanyList();
  }, [fetchCompanyList]);

  const inputchangehandler = useCallback(debounce(handleSearch), []);

  const handlePageChange = (page) => {
    setfilterpage(page);
  };

  const handleEdit = (company) => {
    setSelectedCompany(company);
    setIsEdit(true);
    setDialogOpen(true);
  };

  const handleAddNew = () => {
    setSelectedCompany(null);
    setIsEdit(false);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedCompany(null);
    setIsEdit(false);
  };

  // Refresh list after add/edit/archive
  const handleRefreshList = () => {
    fetchCompanyList();
  };

  useEffect(() => {
    // Prefer totalRecords from Redux (if valid)
    const total = typeof totalRecords === 'number' && totalRecords > 0
      ? totalRecords
      : companyList?.length || 0;

    setCountData(total);

    // Calculate totalPages based on current filterlimit
    const pages = Math.max(1, Math.ceil(total / filterlimit));
    setTotalPages(pages);
  }, [totalRecords, companyList, filterlimit]);

  // Calculate the current page display count
  const currentPageCount = companyList?.length || 0;

  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3">
        </p>
      </div>

      <div className="flex justify-between mb-5">
        <div className="h-10 text-start">
          <Heading>All Companies</Heading>
        </div>

        {isAdmin && (
          <div className="flex gap-2">
            <BtnPrimary
              onClick={handleAddNew}
              className=" flex items-center justify-center px-3 gap-1"
            >
              Add Company
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.712 4.167v11.666M4.878 10h11.667"
                  stroke="#fff"
                  strokeWidth="1.667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </BtnPrimary>
          </div>
        )}
      </div>

      <div className="flex justify-end mb-4">
        <div className='me-3'>
          <StatusSelect
            value={status}
            onChange={(val) => {
              setStatus(val);
            }}
            placeholder="Select Status"
          />
        </div>
        <div className="input-wrapper">
          <div className="input-suffix-start left-3.5">
            <img
              src="/assets/icons-svg/search-lg.svg"
              alt=""
              className="h-5"
            />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>


      <CompaniesList
        companyListData={filteredData}
        onEdit={handleEdit}
        loading={loading}
        onRefresh={handleRefreshList}
        currentPage={filterpage}        // Pass current page (1, 2, 3, etc.)
        itemsPerPage={10}                // Pass items per page
      />
      <AddEditCompany
        dialogOpen={dialogOpen}
        onDialogClose={handleDialogClose}
        companyData={selectedCompany}
        isEdit={isEdit}
        refreshList={handleRefreshList}
      />

      <div className="flex justify-between items-center mt-3">
        {/* Left side - Pagination info */}
        <Pagination
          totalCount={countData}
          pageNumber={filterpage}
          displayPage={currentPageCount}
          UpdatePageLimit={setfilterlimit}
          UpdatePage={setfilterpage}
        />

        {/* Right side - Modern Pagination Controls */}
        {countData > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default Companies